import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container, TextArea, Dropdown
} from "semantic-ui-react";
import ReadAxios from "../../../components/axiosComponent/read";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import CreateAxios from "../../../components/axiosComponent/create";
import UpdateAxios from "../../../components/axiosComponent/update";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { AllRegex } from "../../../utils/validation";
import { ERROR_MESSAGES, INVALID_FIELDS, REQUIRED_FIELDS } from "../../../utils/validationConstant";
import {LOCAL_STORAGE} from '../../../utils/constant'
import {LABELS, PLACE_HOLDERS, BUTTONS} from './shippingLineConstants'
import cogoToast from "cogo-toast";
import MandatoryMark from "../../../components/common/mandatorymark";

const currentUser = LOCAL_STORAGE.customerNo

const InsertShippingLine = ({ values, setFieldValue, touched, errors, t }) => {

  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="ml-3 mr-3 mt-5 mb-5 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {LABELS.shipping_line_code||"Shipping Line Code"}
                  </label>
                </FormUi.Field>
              <FormUi.Field width={4} error={touched.shippingLineCode && errors.shippingLineCode ? true : false} >
                <Fieldmik
                type="text"
                className="ui input pe-5"
                name="shippingLineCode"
                placeholder={PLACE_HOLDERS.shipping_line_code||"Enter Shipping Line Code"}
              />
                      {touched.shippingLineCode && errors.shippingLineCode ? (
                        <div className="error-msg">
                          {errors.shippingLineCode}
                        </div>
                      ) : null}
              </FormUi.Field>
              <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {LABELS.shipping_line||"Shipping Line"}{" "} <MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.shippingLine && errors.shippingLine ? true : false}>
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="shippingLine"
                        placeholder={PLACE_HOLDERS.shipping_line||"Enter Shipping Line"}
                        />
                      {touched.shippingLine && errors.shippingLine ? (
                        <div className="error-msg">
                          {errors.shippingLine}
                        </div>
                      ) : null}
                </FormUi.Field>
              </FormUi.Group>
            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {BUTTONS.submit||"Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikShippingLine = withFormik({
  validationSchema: yup.object({
    shippingLine: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(50, ERROR_MESSAGES.MAX_LENGTH(30)),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
        shippingLine: props.editData.shippingLine || "",
        shippingLineCode: props.editData.shippingLineCode || ""
    };
  },
  async handleSubmit(values, { props, resetForm }) {
    if (props.editData.shippingLineId) {
      UpdateAxios({
        url: "shippingLine",
        payload: { ...values },
        uniqueId: props.editData.shippingLineId,
      })
        .then((res) => {
          cogoToast.success(res.data.message, { position: 'top-right' });
          props.onFormSubmit();
        })
        .catch((err) => {
            cogoToast.error(err.data.message, { position: 'top-right' });
        });
    } else {
      CreateAxios({
        url: "shippingLine",
        payload: { ...values },
      })
        .then((res) => {
          if(res.data.status == 204){
            cogoToast.error(res.data.message, { position: 'top-right' });
            props.onFormSubmit();
            return
          }
          cogoToast.success(res.data.message, { position: 'top-right' });
          props.onFormSubmit();
        })
        .catch((err) => {
          console.log("error shippingLine", err.data);
          cogoToast.error(err?.data?.message, { position: 'top-right' });
        });
    }
  },
})(InsertShippingLine);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("yard")(FormikShippingLine)
);
